import { AxiosError, AxiosRequestConfig } from "axios";
import { Store } from "vuex";
import { SaveKind } from "@/store/modules/saveStatus";

// The writes that carry the mechanic's answers; Afronden (/end) and the tenant PDF do not.
// config.url may already include the baseURL.
const INSTALLATION_URL = /\/installations\/(\d+)(\?|$)/;
const DOCUMENT_URL = /\/installations\/(\d+)\/delivery-document\/(?!generate-pdf\/)/;

function answersWrite(config?: AxiosRequestConfig): { id: number; kind: SaveKind } | null {
  const method = config?.method?.toLowerCase();
  const url = config?.url ?? "";

  const installation = method === "patch" && url.match(INSTALLATION_URL);

  if (installation) {
    return { id: Number(installation[1]), kind: "installation" };
  }

  const document = (method === "put" || method === "post") && url.match(DOCUMENT_URL);

  if (document) {
    return { id: Number(document[1]), kind: "document" };
  }

  return null;
}

export default (store: Store<any>): void => {
  store.$axios.interceptors.response.use(
    response => {
      const write = answersWrite(response.config);

      if (write) {
        store.commit("saveStatus/saved", { ...write, at: Date.now() });
      }

      return response;
    },

    (error: AxiosError) => {
      const write = answersWrite(error.config);

      if (write) {
        store.dispatch("saveStatus/failed", {
          ...write,
          status: error.response?.status,
          message: error.response?.data?.message ?? error.message
        });
      }

      return Promise.reject(error);
    }
  );
};
